module.exports = __webpack_public_path__ + "static/media/tnpa-home2.ccb2ffcc.png";